export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601Date: { input: string; output: string; }
  ISO8601DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
};

export type AccountSession = {
  __typename?: 'AccountSession';
  clientSecret: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  restaurantId: Restaurant;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressAttributes = {
  city: Scalars['String']['input'];
  location?: InputMaybe<LocationAttributes>;
  locationAttributes?: InputMaybe<LocationAttributes>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

/** Autogenerated input type of AdjustLoyaltyAccountMutation */
export type AdjustLoyaltyAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  loyaltyAccountId: Scalars['ID']['input'];
  /** Program whose earning_type governs the adjustment. Must belong to the account's restaurant_group. Defaults to the group's representative program. */
  loyaltyProgramId?: InputMaybe<Scalars['ID']['input']>;
  /** Signed delta applied to points_balance (dollar-based) or punch_balance (item-based). */
  pointsDelta: Scalars['Int']['input'];
  /** Reason for the adjustment. 1..500 chars after stripping whitespace. */
  reason: Scalars['String']['input'];
};

/** Autogenerated return type of AdjustLoyaltyAccountMutation. */
export type AdjustLoyaltyAccountMutationPayload = {
  __typename?: 'AdjustLoyaltyAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  loyaltyAccount?: Maybe<LoyaltyAccount>;
  transaction?: Maybe<LoyaltyTransaction>;
};

export type Algolia = {
  __typename?: 'Algolia';
  appId: Scalars['String']['output'];
  searchApiKey: Scalars['String']['output'];
  userIndexName: Scalars['String']['output'];
};

/** Autogenerated input type of AssignItemGroupTaxRateMutation */
export type AssignItemGroupTaxRateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemGroupId: Scalars['ID']['input'];
  taxRateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AssignItemGroupTaxRateMutation. */
export type AssignItemGroupTaxRateMutationPayload = {
  __typename?: 'AssignItemGroupTaxRateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  itemGroup?: Maybe<ItemGroup>;
};

export type AssistantThread = {
  __typename?: 'AssistantThread';
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  restaurant: Restaurant;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum Auth {
  /** Apple OAuth */
  Apple = 'APPLE',
  /** Google OAuth */
  Google = 'GOOGLE',
  /** User has no authentication */
  None = 'NONE',
  /** User does not exist */
  NotFound = 'NOT_FOUND',
  /** Password */
  Password = 'PASSWORD',
  /** Phone */
  Phone = 'PHONE',
  /** Other */
  Unknown = 'UNKNOWN'
}

export type Bonus = {
  __typename?: 'Bonus';
  createdAt: Scalars['ISO8601DateTime']['output'];
  employeeAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  restaurantAmount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CancelOrderItemsMutation */
export type CancelOrderItemsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  orderItemIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CancelOrderItemsMutation. */
export type CancelOrderItemsMutationPayload = {
  __typename?: 'CancelOrderItemsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  order?: Maybe<Order>;
};

export enum CancelReason {
  /** Restaurant is closed */
  Closed = 'CLOSED',
  /** Item Unavailable */
  ItemsUnavailable = 'ITEMS_UNAVAILABLE',
  /** Rejected */
  Rejected = 'REJECTED',
  /** timed order */
  Timedout = 'TIMEDOUT'
}

export enum CancelableStatus {
  /** Can be canceled */
  Cancelable = 'CANCELABLE',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Picked up */
  DeliveryPickedUp = 'DELIVERY_PICKED_UP',
  /** Cannot be canceled */
  Uncancelable = 'UNCANCELABLE'
}

export type CompletionMessage = {
  __typename?: 'CompletionMessage';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type CompletionMessageAttributes = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

/** Autogenerated input type of CreateAssistantThreadMutation */
export type CreateAssistantThreadMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  restaurantId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAssistantThreadMutation. */
export type CreateAssistantThreadMutationPayload = {
  __typename?: 'CreateAssistantThreadMutationPayload';
  assistantThread?: Maybe<AssistantThread>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateCompletionMutation */
export type CreateCompletionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messages: Array<CompletionMessageAttributes>;
};

/** Autogenerated return type of CreateCompletionMutation. */
export type CreateCompletionMutationPayload = {
  __typename?: 'CreateCompletionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  completion?: Maybe<CompletionMessage>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateDirectUploadMutation */
export type CreateDirectUploadMutationInput = {
  /** File size (bytes) */
  byteSize: Scalars['Int']['input'];
  /** MD5 file checksum as base64 */
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** File content type */
  contentType: Scalars['String']['input'];
  /** Original file name */
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDirectUploadMutation. */
export type CreateDirectUploadMutationPayload = {
  __typename?: 'CreateDirectUploadMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** Headers for the upload request */
  headers?: Maybe<Scalars['String']['output']>;
  /** Signed blob ID for the upload */
  signedBlobId?: Maybe<Scalars['String']['output']>;
  /** URL to upload the file to */
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDiscountMutation */
export type CreateDiscountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  kind: DiscountKind;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Float']['input']>;
  restaurantId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
  valueType: DiscountValue;
};

/** Autogenerated return type of CreateDiscountMutation. */
export type CreateDiscountMutationPayload = {
  __typename?: 'CreateDiscountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateEmploymentMutation */
export type CreateEmploymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  permissions?: InputMaybe<Array<Permission>>;
  restaurantId: Scalars['ID']['input'];
  tippable: Scalars['Boolean']['input'];
  user: CreateUserAttributes;
};

/** Autogenerated return type of CreateEmploymentMutation. */
export type CreateEmploymentMutationPayload = {
  __typename?: 'CreateEmploymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateInvoiceMutation */
export type CreateInvoiceMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  depositAmount?: InputMaybe<Scalars['Int']['input']>;
  depositPercent?: InputMaybe<Scalars['Float']['input']>;
  eventDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  invoiceItemsAttributes: Array<InvoiceItemAttributes>;
  name?: InputMaybe<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
  taxExemptNote?: InputMaybe<Scalars['String']['input']>;
  tippable?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<CreateUserAttributes>;
};

/** Autogenerated return type of CreateInvoiceMutation. */
export type CreateInvoiceMutationPayload = {
  __typename?: 'CreateInvoiceMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of CreateItemGroupMutation */
export type CreateItemGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  defaultTaxRateId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  menuId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  restaurantId: Scalars['ID']['input'];
  scheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  schedulesAttributes?: InputMaybe<Array<ScheduleAttributes>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateItemGroupMutation. */
export type CreateItemGroupMutationPayload = {
  __typename?: 'CreateItemGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  itemGroup?: Maybe<ItemGroup>;
};

/** Autogenerated input type of CreateItemMutation */
export type CreateItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenPos?: InputMaybe<Scalars['Boolean']['input']>;
  imageBlobId?: InputMaybe<Scalars['ID']['input']>;
  itemGroupId: Scalars['ID']['input'];
  modifierGroupsAttributes?: InputMaybe<Array<ModifierGroupAttributes>>;
  name?: InputMaybe<Scalars['String']['input']>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  stationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  submenuIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxIncluded: Scalars['Boolean']['input'];
  taxRateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateItemMutation. */
export type CreateItemMutationPayload = {
  __typename?: 'CreateItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  item?: Maybe<Item>;
};

/** Autogenerated input type of CreateLoyaltyProgramMutation */
export type CreateLoyaltyProgramMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  earningItemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  earningThreshold?: InputMaybe<Scalars['Int']['input']>;
  earningType?: InputMaybe<Scalars['String']['input']>;
  enrollmentDescription?: InputMaybe<Scalars['String']['input']>;
  enrollmentHeading?: InputMaybe<Scalars['String']['input']>;
  enrollmentScreenPlacement?: InputMaybe<LoyaltyEnrollmentPlacement>;
  pointsPerDollar?: InputMaybe<Scalars['Int']['input']>;
  progressMessage?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['ID']['input'];
  rewardEarnedMessage?: InputMaybe<Scalars['String']['input']>;
  rewardIncludesModifiers?: InputMaybe<Scalars['Boolean']['input']>;
  rewardItemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  smsProgressEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  starterPoints?: InputMaybe<Scalars['Int']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateLoyaltyProgramMutation. */
export type CreateLoyaltyProgramMutationPayload = {
  __typename?: 'CreateLoyaltyProgramMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
};

/** Autogenerated input type of CreateModifierGroupMutation */
export type CreateModifierGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isVariant?: InputMaybe<Scalars['Boolean']['input']>;
  itemId: Scalars['ID']['input'];
  maxSelect?: InputMaybe<Scalars['Int']['input']>;
  minSelect?: InputMaybe<Scalars['Int']['input']>;
  modifiersAttributes?: InputMaybe<Array<ModifierAttributes>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of CreateModifierGroupMutation. */
export type CreateModifierGroupMutationPayload = {
  __typename?: 'CreateModifierGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  modifierGroup?: Maybe<ModifierGroup>;
};

/** Autogenerated input type of CreateModifierMutation */
export type CreateModifierMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  modifierGroupId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateModifierMutation. */
export type CreateModifierMutationPayload = {
  __typename?: 'CreateModifierMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  modifier?: Maybe<Modifier>;
};

/** Autogenerated input type of CreateOrderExportMutation */
export type CreateOrderExportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  endDate: Scalars['ISO8601Date']['input'];
  /** Seconds after midnight */
  endTime?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<OrderExportFormatEnum>;
  restaurantIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  /** Seconds after midnight */
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateOrderExportMutation. */
export type CreateOrderExportMutationPayload = {
  __typename?: 'CreateOrderExportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreatePaymentMutation */
export type CreatePaymentMutationInput = {
  amount: Scalars['Int']['input'];
  canMarket?: InputMaybe<Scalars['Boolean']['input']>;
  cashCollected?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  giftCardId?: InputMaybe<Scalars['ID']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  largePartyTip?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  payableUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  paymentIntentId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  paymentType: OrderPayment;
  phone?: InputMaybe<Scalars['String']['input']>;
  serviceFee: Scalars['Int']['input'];
  status?: InputMaybe<OrderPaymentStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreatePaymentMutation. */
export type CreatePaymentMutationPayload = {
  __typename?: 'CreatePaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payment?: Maybe<Payment>;
};

/** Autogenerated input type of CreatePayoutMutation */
export type CreatePayoutMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Confirmed gross amount in cents for an Instant Payout */
  expectedAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Use Instant Payout when true and standard payout when false */
  instant: Scalars['Boolean']['input'];
  /** Nonblank idempotency key for this payout request */
  requestKey: Scalars['String']['input'];
  restaurantId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePayoutMutation. */
export type CreatePayoutMutationPayload = {
  __typename?: 'CreatePayoutMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payout?: Maybe<Payout>;
};

/** Autogenerated input type of CreateRefundMutation */
export type CreateRefundMutationInput = {
  cancel?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  orderItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderSurchargeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundTip?: InputMaybe<Scalars['Boolean']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateRefundMutation. */
export type CreateRefundMutationPayload = {
  __typename?: 'CreateRefundMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  refund?: Maybe<Refund>;
};

/** Autogenerated input type of CreateSavedPromptMutation */
export type CreateSavedPromptMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateSavedPromptMutation. */
export type CreateSavedPromptMutationPayload = {
  __typename?: 'CreateSavedPromptMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  savedPrompt?: Maybe<SavedPrompt>;
};

/** Autogenerated input type of CreateScheduledOrderExportMutation */
export type CreateScheduledOrderExportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  endDate: Scalars['ISO8601Date']['input'];
  /** Seconds after midnight */
  endTime?: InputMaybe<Scalars['Int']['input']>;
  restaurantIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  /** Seconds after midnight */
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateScheduledOrderExportMutation. */
export type CreateScheduledOrderExportMutationPayload = {
  __typename?: 'CreateScheduledOrderExportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateShiftMutation */
export type CreateShiftMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentId: Scalars['ID']['input'];
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startAt: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateShiftMutation. */
export type CreateShiftMutationPayload = {
  __typename?: 'CreateShiftMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  shift?: Maybe<Shift>;
};

/** Autogenerated input type of CreateTaxRateMutation */
export type CreateTaxRateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rate: Scalars['Int']['input'];
  restaurantId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTaxRateMutation. */
export type CreateTaxRateMutationPayload = {
  __typename?: 'CreateTaxRateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  taxRate?: Maybe<TaxRate>;
};

/** Attributes for creating a user */
export type CreateUserAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type CustomerStats = {
  __typename?: 'CustomerStats';
  amountSpent: Scalars['Int']['output'];
  averageSpent: Scalars['Int']['output'];
  averageTipPercent: Scalars['Float']['output'];
  firstOrder?: Maybe<Order>;
  lastOrder?: Maybe<Order>;
  /**
   * Loyalty accounts across every restaurant the customer is enrolled in (cross-restaurant).
   *
   * Authentication: Auth Token only.
   */
  loyaltyAccounts: Array<LoyaltyAccount>;
  numOrders: Scalars['Int']['output'];
  orders: Array<Order>;
  restaurants: Array<Restaurant>;
  topItems: Array<ItemStats>;
  user: User;
};


export type CustomerStatsOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerStatsTopItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Customership = {
  __typename?: 'Customership';
  amountSpent?: Maybe<Scalars['Int']['output']>;
  canMarket?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstOrderPaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastOrderPaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numOrders?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Restaurant>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for Customership. */
export type CustomershipConnection = {
  __typename?: 'CustomershipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomershipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Customership>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomershipEdge = {
  __typename?: 'CustomershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Customership>;
};

export type CustomershipOrderByAttributes = {
  amountSpent?: InputMaybe<SortDirection>;
  canMarket?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  numOrders?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
};

/** Autogenerated input type of DeleteShiftMutation */
export type DeleteShiftMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteShiftMutation. */
export type DeleteShiftMutationPayload = {
  __typename?: 'DeleteShiftMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  shift?: Maybe<Shift>;
};

export type Delivery = {
  __typename?: 'Delivery';
  cartwheelJobId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhone?: Maybe<Scalars['String']['output']>;
  dropoffEtaAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  photoUrls?: Maybe<Array<Scalars['String']['output']>>;
  pickupEtaAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: DeliveryStatus;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliveryQuote?: Maybe<DeliveryQuote>;
  discardedAt: Scalars['ISO8601DateTime']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  location?: Maybe<Location>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type DeliveryAddressDeliveryQuoteArgs = {
  menuId: Scalars['ID']['input'];
};

export type DeliveryAddressAttributes = {
  city?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  locationAttributes?: InputMaybe<LocationAttributes>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryQuote = {
  __typename?: 'DeliveryQuote';
  available: Scalars['Boolean']['output'];
  /** Duration in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  estimatedDropoffAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimatedPickupAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export enum DeliveryStatus {
  /** accepted */
  Accepted = 'ACCEPTED',
  /** at_pickup */
  AtPickup = 'AT_PICKUP',
  /** done_cancelled, cancelled */
  Canceled = 'CANCELED',
  /** done_delivered, completed */
  Delivered = 'DELIVERED',
  /** done_cannot_deliver */
  DeliveryProblem = 'DELIVERY_PROBLEM',
  /** picked_up, transit_to_dropoff, at_dropoff */
  DropoffEnroute = 'DROPOFF_ENROUTE',
  /** transit_to_pickup, food_not_ready */
  PickupEnroute = 'PICKUP_ENROUTE',
  /** return_in_progress, returned */
  Returned = 'RETURNED',
  /** submitted and waiting for driver */
  Submitted = 'SUBMITTED',
  /** another status */
  Unknown = 'UNKNOWN'
}

export type Device = {
  __typename?: 'Device';
  appVersion?: Maybe<Scalars['String']['output']>;
  clientUuid: Scalars['String']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  osInfo?: Maybe<Scalars['String']['output']>;
  restaurantId: Scalars['ID']['output'];
  settings: Scalars['JSON']['output'];
  settingsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updateId?: Maybe<Scalars['String']['output']>;
};

export type Discount = {
  __typename?: 'Discount';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind: DiscountKind;
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value?: Maybe<Scalars['Int']['output']>;
  valueType: DiscountValue;
};

export enum DiscountKind {
  /** item */
  Item = 'ITEM',
  /** order */
  Order = 'ORDER'
}

export enum DiscountValue {
  /** discount percent - basis points */
  BasisPoints = 'BASIS_POINTS',
  /** discount amount - cents */
  Cents = 'CENTS'
}

/** Autogenerated input type of EditAssistantThreadMutation */
export type EditAssistantThreadMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  restaurantId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditAssistantThreadMutation. */
export type EditAssistantThreadMutationPayload = {
  __typename?: 'EditAssistantThreadMutationPayload';
  assistantThread?: Maybe<AssistantThread>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of EditDiscountMutation */
export type EditDiscountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  kind?: InputMaybe<DiscountKind>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  valueType?: InputMaybe<DiscountValue>;
};

/** Autogenerated return type of EditDiscountMutation. */
export type EditDiscountMutationPayload = {
  __typename?: 'EditDiscountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  errors: Array<Error>;
};

/** Autogenerated input type of EditEmploymentMutation */
export type EditEmploymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<Permission>>;
  tippable?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<EditUserAttributes>;
};

/** Autogenerated return type of EditEmploymentMutation. */
export type EditEmploymentMutationPayload = {
  __typename?: 'EditEmploymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Error>;
};

/** Autogenerated input type of EditInvoiceMutation */
export type EditInvoiceMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  depositAmount?: InputMaybe<Scalars['Int']['input']>;
  depositPercent?: InputMaybe<Scalars['Float']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  eventDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
  invoiceItemsAttributes: Array<InvoiceItemAttributes>;
  name?: InputMaybe<Scalars['ID']['input']>;
  taxExemptNote?: InputMaybe<Scalars['String']['input']>;
  tippable?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<EditUserAttributes>;
};

/** Autogenerated return type of EditInvoiceMutation. */
export type EditInvoiceMutationPayload = {
  __typename?: 'EditInvoiceMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of EditItemGroupMutation */
export type EditItemGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  defaultTaxRateId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  schedulesAttributes?: InputMaybe<Array<ScheduleAttributes>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditItemGroupMutation. */
export type EditItemGroupMutationPayload = {
  __typename?: 'EditItemGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  itemGroup?: Maybe<ItemGroup>;
};

/** Autogenerated input type of EditItemMutation */
export type EditItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenPos?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  imageBlobId?: InputMaybe<Scalars['ID']['input']>;
  itemGroupId?: InputMaybe<Scalars['ID']['input']>;
  modifierGroupsAttributes?: InputMaybe<Array<ModifierGroupAttributes>>;
  name?: InputMaybe<Scalars['String']['input']>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  stationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  submenuIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  taxRateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of EditItemMutation. */
export type EditItemMutationPayload = {
  __typename?: 'EditItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  item?: Maybe<Item>;
};

/** Autogenerated input type of EditMenuMutation */
export type EditMenuMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledOrders?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  minGrossSubtotal?: InputMaybe<Scalars['Int']['input']>;
  minLeadMinutes?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['ID']['input'];
  scheduledSlotCapacity?: InputMaybe<Scalars['Int']['input']>;
  scheduledSlotLength?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of EditMenuMutation. */
export type EditMenuMutationPayload = {
  __typename?: 'EditMenuMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
};

/** Autogenerated input type of EditModifierGroupMutation */
export type EditModifierGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultModifierId?: InputMaybe<Scalars['ID']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isVariant?: InputMaybe<Scalars['Boolean']['input']>;
  maxSelect?: InputMaybe<Scalars['Int']['input']>;
  minSelect?: InputMaybe<Scalars['Int']['input']>;
  modifiersAttributes?: InputMaybe<Array<ModifierAttributes>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of EditModifierGroupMutation. */
export type EditModifierGroupMutationPayload = {
  __typename?: 'EditModifierGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  modifierGroup?: Maybe<ModifierGroup>;
};

/** Autogenerated input type of EditModifierMutation */
export type EditModifierMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  modifierGroupId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of EditModifierMutation. */
export type EditModifierMutationPayload = {
  __typename?: 'EditModifierMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  modifier?: Maybe<Modifier>;
};

/** Autogenerated input type of EditOrderMutation */
export type EditOrderMutationInput = {
  cancelReason?: InputMaybe<CancelReason>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<OrderStatus>;
};

/** Autogenerated return type of EditOrderMutation. */
export type EditOrderMutationPayload = {
  __typename?: 'EditOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  order?: Maybe<Order>;
};

/** Autogenerated input type of EditRestaurantGroupMutation */
export type EditRestaurantGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  wordmarkUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditRestaurantGroupMutation. */
export type EditRestaurantGroupMutationPayload = {
  __typename?: 'EditRestaurantGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  restaurantGroup?: Maybe<RestaurantGroup>;
};

/** Autogenerated input type of EditRestaurantSettingMutation */
export type EditRestaurantSettingMutationInput = {
  addressAttributes?: InputMaybe<AddressAttributes>;
  assistantContext?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  cashRoundingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultOnlineTipPercent?: InputMaybe<Scalars['Int']['input']>;
  defaultTaxRateId?: InputMaybe<Scalars['ID']['input']>;
  enableDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  enableKiosk?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlineSpecialInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  enablePoem?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  heroImageBlobId?: InputMaybe<Scalars['String']['input']>;
  itemPriceIncludesTax?: InputMaybe<Scalars['Boolean']['input']>;
  kioskBackgroundImageBlobId?: InputMaybe<Scalars['String']['input']>;
  largePartyDefaultTipPercent?: InputMaybe<Scalars['Int']['input']>;
  locationAttributes?: InputMaybe<LocationAttributes>;
  logoImageBlobId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlineAutoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  openingHours?: InputMaybe<Array<OpeningHoursAttributes>>;
  openingHoursExceptionsAttributes?: InputMaybe<Array<OpeningHoursExceptionAttributes>>;
  perDeviceCashDrawers?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pickupInstructions?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['ID']['input'];
  /** Sales tax rate in thousandths of a percent (e.g. 10.55% = 10550) */
  salesTaxRate?: InputMaybe<Scalars['Int']['input']>;
  socialReviewsUrl?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tipAfterTax?: InputMaybe<Scalars['Boolean']['input']>;
  tipAmounts?: InputMaybe<Array<Scalars['Int']['input']>>;
  tipPercentages?: InputMaybe<Array<Scalars['Int']['input']>>;
  tipThreshold?: InputMaybe<Scalars['Int']['input']>;
  waitTime?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of EditRestaurantSettingMutation. */
export type EditRestaurantSettingMutationPayload = {
  __typename?: 'EditRestaurantSettingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  restaurantSetting?: Maybe<RestaurantSetting>;
};

/** Autogenerated input type of EditSavedPromptMutation */
export type EditSavedPromptMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Float']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditSavedPromptMutation. */
export type EditSavedPromptMutationPayload = {
  __typename?: 'EditSavedPromptMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  savedPrompt?: Maybe<SavedPrompt>;
};

/** Autogenerated input type of EditShiftMutation */
export type EditShiftMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of EditShiftMutation. */
export type EditShiftMutationPayload = {
  __typename?: 'EditShiftMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  shift?: Maybe<Shift>;
};

/** Autogenerated input type of EditTaxRateMutation */
export type EditTaxRateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditTaxRateMutation. */
export type EditTaxRateMutationPayload = {
  __typename?: 'EditTaxRateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  taxRate?: Maybe<TaxRate>;
};

/** Attributes for editing a user */
export type EditUserAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type EditableDeviceSettingsInput = {
  cardPaymentsCanCreateSetupIntents?: InputMaybe<Scalars['Boolean']['input']>;
  cardPaymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cashDrawerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutEnableTableMarkers?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutShowAddCustomerScreen?: InputMaybe<Scalars['Boolean']['input']>;
  giftCardsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  kdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  kioskAcceptCash?: InputMaybe<Scalars['Boolean']['input']>;
  kioskEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  kioskName?: InputMaybe<Scalars['String']['input']>;
  kioskRequirePackaging?: InputMaybe<Scalars['Boolean']['input']>;
  printLogo?: InputMaybe<Scalars['Boolean']['input']>;
  printReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  printStickers?: InputMaybe<Scalars['Boolean']['input']>;
  printTickets?: InputMaybe<Scalars['Boolean']['input']>;
  soundNewOnlineOrders?: InputMaybe<Scalars['Boolean']['input']>;
  soundNewTickets?: InputMaybe<Scalars['Boolean']['input']>;
  soundReminderFirstEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  soundReminderFirstMinutes?: InputMaybe<Scalars['Int']['input']>;
  soundReminderSecondEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  soundReminderSecondMinutes?: InputMaybe<Scalars['Int']['input']>;
  soundReminderThirdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  soundReminderThirdMinutes?: InputMaybe<Scalars['Int']['input']>;
  soundTicketReminders?: InputMaybe<Scalars['Boolean']['input']>;
  storefrontEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tablesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tipsEnableLargePartyTipScreen?: InputMaybe<Scalars['Boolean']['input']>;
  tipsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tipsShowTipScreenEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  tipsTipBeforePayment?: InputMaybe<Scalars['Boolean']['input']>;
  tipsTipOnPaper?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Employment = {
  __typename?: 'Employment';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discarded: Scalars['Boolean']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasActiveShift: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  orders?: Maybe<Array<Order>>;
  permissions?: Maybe<Array<Permission>>;
  restaurant: Restaurant;
  shifts?: Maybe<Array<Shift>>;
  tickets?: Maybe<Array<Ticket>>;
  tippable: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};


export type EmploymentShiftsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Error Type */
export type Error = {
  __typename?: 'Error';
  /** Error message */
  message: Scalars['String']['output'];
  /** Error path */
  path?: Maybe<Array<Scalars['String']['output']>>;
  /** Error type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ExternalOrderTotal = {
  __typename?: 'ExternalOrderTotal';
  /** Stream order net total in cents for this provider */
  amount: Scalars['Int']['output'];
  /** Stream provider name */
  sourceLabel: Scalars['String']['output'];
};

export type FeeSchedule = {
  __typename?: 'FeeSchedule';
  giftCardPurchase: Scalars['Boolean']['output'];
  payableType: Scalars['String']['output'];
  paymentType: OrderPayment;
  processingFeeJsFunc: Scalars['String']['output'];
  restaurant: Restaurant;
};

export enum Fulfillment {
  /** On demand delivery */
  Delivery = 'DELIVERY',
  /** Pickup in person */
  Pickup = 'PICKUP'
}

export type GiftCard = {
  __typename?: 'GiftCard';
  balance: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  initialValue: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  lastTransactionAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  order?: Maybe<Order>;
  payments: Array<Payment>;
  restaurantGroup: RestaurantGroup;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type GiftCardTransaction = {
  __typename?: 'GiftCardTransaction';
  amount?: Maybe<Scalars['Int']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  giftCard: GiftCard;
  id: Scalars['ID']['output'];
  order: Order;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type HourlySales = {
  __typename?: 'HourlySales';
  hour: Scalars['Int']['output'];
  netSales: Scalars['Int']['output'];
  /** Total value in cents */
  tips: Scalars['Int']['output'];
};

export type InstantPayoutPreview = {
  __typename?: 'InstantPayoutPreview';
  amount: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
  estimatedFee: Scalars['Int']['output'];
  netAmount: Scalars['Int']['output'];
  stripeBalanceAdjustment: Scalars['Int']['output'];
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  /** Outstanding deposit if one is unpaid, otherwise the full remaining balance */
  amountDueNow: Scalars['Int']['output'];
  balanceDue: Scalars['Int']['output'];
  canDiscard: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deposit in cents; derived from depositPercent when that is set */
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositPaid: Scalars['Boolean']['output'];
  depositPercent?: Maybe<Scalars['Float']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date the remaining balance is due */
  eventDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  invoiceItems: Array<InvoiceItem>;
  name?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** subtotal + unincludedTax */
  payableTotal: Scalars['Int']['output'];
  paymentStatus: OrderPaymentStatus;
  payments: Array<Payment>;
  processingFee: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  stage: InvoiceStage;
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  taxExempt: Scalars['Boolean']['output'];
  taxExemptNote?: Maybe<Scalars['String']['output']>;
  tip?: Maybe<Scalars['Int']['output']>;
  tippable: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
  unincludedTax: Scalars['Int']['output'];
  unpaidBalance: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

/** The connection type for Invoice. */
export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Invoice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice: Invoice;
  key: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  unitPrice: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Attributes for creating an invoice item */
export type InvoiceItemAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  unitPrice: Scalars['Int']['input'];
};

export type InvoiceOrderByAttributes = {
  createdAt?: InputMaybe<SortDirection>;
  eventDate?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  paymentStatus?: InputMaybe<SortDirection>;
  subtotal?: InputMaybe<SortDirection>;
};

export enum InvoiceStage {
  /** Deposit covered; the remaining balance is outstanding */
  BalanceDue = 'BALANCE_DUE',
  /** Deposit configured and not yet covered */
  DepositDue = 'DEPOSIT_DUE',
  /** No deposit configured; the full balance is payable */
  NoDeposit = 'NO_DEPOSIT',
  /** Balance outstanding past the event date */
  Overdue = 'OVERDUE',
  /** Fully paid */
  Paid = 'PAID'
}

export type Item = {
  __typename?: 'Item';
  color?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  decoratedName?: Maybe<Scalars['String']['output']>;
  decoratedShortName?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveTaxRate: TaxRate;
  hiddenOnline: Scalars['Boolean']['output'];
  hiddenPos: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Item Group */
  itemGroup: ItemGroup;
  /** @deprecated Use color instead */
  kdsColor?: Maybe<Scalars['String']['output']>;
  /** Modifier Group */
  modifierGroups?: Maybe<Array<ModifierGroup>>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  position: Scalars['Float']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  stationIds: Array<Scalars['ID']['output']>;
  stations: Array<Station>;
  submenus: Array<Submenu>;
  taxIncluded: Scalars['Boolean']['output'];
  taxRate?: Maybe<TaxRate>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ItemModifierGroupsArgs = {
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemGroup = {
  __typename?: 'ItemGroup';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  decoratedName?: Maybe<Scalars['String']['output']>;
  decoratedShortName?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  defaultTaxRate?: Maybe<TaxRate>;
  description?: Maybe<Scalars['String']['output']>;
  hiddenOnline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Items */
  items: Array<Item>;
  menu: Menu;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Float']['output'];
  scheduleEnabled: Scalars['Boolean']['output'];
  schedules: Array<Schedule>;
  shortName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ItemGroupItemsArgs = {
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemRefund = {
  __typename?: 'ItemRefund';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  orderItem: OrderItem;
  quantity?: Maybe<Scalars['Int']['output']>;
  refund: Refund;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ItemStats = {
  __typename?: 'ItemStats';
  /** Total value in cents */
  amount: Scalars['Int']['output'];
  /** Total discount in cents */
  discount: Scalars['Int']['output'];
  itemGroupName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type Like = {
  __typename?: 'Like';
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type Location = {
  __typename?: 'Location';
  /** Latitude */
  lat: Scalars['Float']['output'];
  /** Longitude */
  lon: Scalars['Float']['output'];
};

export type LocationAttributes = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type LoyaltyAccount = {
  __typename?: 'LoyaltyAccount';
  /** Raw item-based punch arithmetic (floor(punch_balance / earning_threshold)); NOT surface-aware. Prefer `rewardsAvailable(surface:)` for redemption gating. Null for dollar-based programs. */
  availableRewards?: Maybe<Scalars['Int']['output']>;
  /** Whether the current viewer is permitted to call adjustLoyaltyAccount on this account (owner/admin of any restaurant in the account's group). */
  canAdjust: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lifetimePoints: Scalars['Int']['output'];
  /** Representative program for progress/rewards — the querying restaurant's program if context[:loyalty_program_restaurant] is set, else the oldest active program in the group. Raises when the group has no programs. */
  loyaltyProgram: LoyaltyProgram;
  /** Authentication: Auth Token only. */
  loyaltyTransactions: Array<LoyaltyTransaction>;
  pointsBalance: Scalars['Int']['output'];
  /** Points still needed for a redeemable reward on the querying surface. Returns 0 when no reward is redeemable on that surface (mirrors `rewardsAvailable` so the badge and progress can't disagree). Same surface semantics as `rewardsAvailable`. */
  pointsToNextReward: Scalars['Int']['output'];
  /** Points toward next reward */
  progress: Scalars['Int']['output'];
  punchBalance: Scalars['Int']['output'];
  /** Restaurant that owns the representative program. */
  restaurant: Restaurant;
  restaurantGroup: RestaurantGroup;
  /** Redemption count for the querying surface. Pass POS from cashier/kiosk, ONLINE from storefront. */
  rewardsAvailable: Scalars['Int']['output'];
  smsOptedOut: Scalars['Boolean']['output'];
  totalRedemptions: Scalars['Int']['output'];
  /**
   * Paginated transaction history, most recent first.
   *
   * Authentication: Auth Token only.
   */
  transactions: LoyaltyTransactionConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};


export type LoyaltyAccountPointsToNextRewardArgs = {
  surface?: InputMaybe<RedemptionSurface>;
};


export type LoyaltyAccountRewardsAvailableArgs = {
  surface?: InputMaybe<RedemptionSurface>;
};


export type LoyaltyAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltyDailyStat = {
  __typename?: 'LoyaltyDailyStat';
  date: Scalars['ISO8601Date']['output'];
  enrollments: Scalars['Int']['output'];
  pointsEarned: Scalars['Int']['output'];
  punchesEarned: Scalars['Int']['output'];
  rewardsRedeemed: Scalars['Int']['output'];
};

export enum LoyaltyEnrollmentPlacement {
  /** Show enrollment screen after payment */
  PostPayment = 'POST_PAYMENT',
  /** Show enrollment screen before tip selection */
  PreTip = 'PRE_TIP'
}

export type LoyaltyProgram = {
  __typename?: 'LoyaltyProgram';
  active: Scalars['Boolean']['output'];
  /** Members with at least one order in date range */
  activeMembersCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  dailyStats: Array<LoyaltyDailyStat>;
  displayName?: Maybe<Scalars['String']['output']>;
  earningItemGroupIds: Array<Scalars['ID']['output']>;
  earningThreshold?: Maybe<Scalars['Int']['output']>;
  earningType: Scalars['String']['output'];
  /** Total enrolled loyalty accounts */
  enrolledCount: Scalars['Int']['output'];
  enrollmentDescription?: Maybe<Scalars['String']['output']>;
  enrollmentHeading?: Maybe<Scalars['String']['output']>;
  enrollmentScreenPlacement: LoyaltyEnrollmentPlacement;
  id: Scalars['ID']['output'];
  /** Fraction of identified customers who are loyalty members (0.0-1.0) */
  loyaltyPenetration: Scalars['Float']['output'];
  pointsPerDollar?: Maybe<Scalars['Int']['output']>;
  progressMessage?: Maybe<Scalars['String']['output']>;
  restaurant: Restaurant;
  /** Avg spend comparison between members and non-members */
  revenueComparison: LoyaltyRevenueComparison;
  /** Total cost of comped items in cents */
  rewardCost: Scalars['Int']['output'];
  rewardEarnedMessage?: Maybe<Scalars['String']['output']>;
  rewardIncludesModifiers: Scalars['Boolean']['output'];
  rewardItemGroupIds: Array<Scalars['ID']['output']>;
  smsProgressEnabled: Scalars['Boolean']['output'];
  starterPoints: Scalars['Int']['output'];
  /** Top users by redemption count in a date range */
  topRedeemers: Array<LoyaltyTopRedeemer>;
  /** Sum of lifetime points across all accounts */
  totalPointsEarned: Scalars['Int']['output'];
  /** Total punches earned (item-based programs) */
  totalPunchesEarned: Scalars['Int']['output'];
  /** Total rewards redeemed across all accounts */
  totalRewardsRedeemed: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};


export type LoyaltyProgramActiveMembersCountArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramDailyStatsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramLoyaltyPenetrationArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramRevenueComparisonArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramRewardCostArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramTopRedeemersArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};

export type LoyaltyRevenueComparison = {
  __typename?: 'LoyaltyRevenueComparison';
  /** Average gross order subtotal (cents) for post-enrollment member orders */
  memberAvgSpend: Scalars['Int']['output'];
  /** Count of post-enrollment member orders in the range */
  memberOrderCount: Scalars['Int']['output'];
  /** Fraction of identified members with 2+ post-enrollment orders (0.0-1.0) */
  memberRepeatRate: Scalars['Float']['output'];
  /** Net revenue (cents) from post-enrollment member orders */
  memberTotalRevenue: Scalars['Int']['output'];
  /** Average order subtotal (cents) for non-member orders (includes guests) */
  nonMemberAvgSpend: Scalars['Int']['output'];
  /** Count of non-member orders in the range (includes guests) */
  nonMemberOrderCount: Scalars['Int']['output'];
  /** Fraction of identified non-members with 2+ orders (0.0-1.0) */
  nonMemberRepeatRate: Scalars['Float']['output'];
};

export type LoyaltyTopRedeemer = {
  __typename?: 'LoyaltyTopRedeemer';
  /** Redemption count in the date range */
  redemptions: Scalars['Int']['output'];
  /** Gross spend (cents) in the date range, including comped items */
  totalSpend?: Maybe<Scalars['Int']['output']>;
  userName: Scalars['String']['output'];
  userPhone?: Maybe<Scalars['String']['output']>;
  /** Number of non-canceled orders in the date range */
  visitCount?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltyTransaction = {
  __typename?: 'LoyaltyTransaction';
  /** Operator who initiated the transaction (populated for manual_adjustment rows). */
  actor?: Maybe<User>;
  balanceAfter: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  points: Scalars['Int']['output'];
  /** Balance immediately before this transaction. Nullable for pre-feature historical rows. */
  previousBalance?: Maybe<Scalars['Int']['output']>;
  /** Operator-supplied reason (populated for manual_adjustment rows). */
  reason?: Maybe<Scalars['String']['output']>;
  /** Name of the comped order item for redeem and refund-reversal (adjustment) rows. Appends " +N more" when an order had multiple loyalty redemptions. */
  redeemedItemName?: Maybe<Scalars['String']['output']>;
  transactionType: LoyaltyTransactionTypeEnum;
};

/** The connection type for LoyaltyTransaction. */
export type LoyaltyTransactionConnection = {
  __typename?: 'LoyaltyTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LoyaltyTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LoyaltyTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LoyaltyTransactionEdge = {
  __typename?: 'LoyaltyTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LoyaltyTransaction>;
};

export enum LoyaltyTransactionTypeEnum {
  /** System adjustment (e.g. refund reversal) */
  Adjustment = 'ADJUSTMENT',
  /** Points earned from a purchase */
  Earn = 'EARN',
  /** Operator-initiated manual adjustment */
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  /** Points redeemed for a reward */
  Redeem = 'REDEEM',
  /** Starter points granted on enrollment */
  Starter = 'STARTER'
}

export type Menu = {
  __typename?: 'Menu';
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  /** Cartwheel Team ID */
  deliveryTeamId?: Maybe<Scalars['ID']['output']>;
  enableScheduledOrders: Scalars['Boolean']['output'];
  /** Special item used to create gift card order */
  giftCardItem: Item;
  id: Scalars['ID']['output'];
  /** Item Groups */
  itemGroups: Array<ItemGroup>;
  /** Minimum gross subtotal for an order */
  minGrossSubtotal: Scalars['Int']['output'];
  /** Minimum lead time for an order */
  minLeadMinutes: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Restaurant */
  restaurant: Restaurant;
  /** Maximum number of scheduled orders per slot; null means unlimited capacity */
  scheduledSlotCapacity?: Maybe<Scalars['Int']['output']>;
  /** Length of a scheduled slot in minutes */
  scheduledSlotLength: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type MenuItemGroupsArgs = {
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Modifier = {
  __typename?: 'Modifier';
  createdAt: Scalars['ISO8601DateTime']['output'];
  decoratedName?: Maybe<Scalars['String']['output']>;
  decoratedShortName?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  hiddenOnline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Modifier Group */
  modifierGroup: ModifierGroup;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  position: Scalars['Float']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ModifierAttributes = {
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

export type ModifierGroup = {
  __typename?: 'ModifierGroup';
  createdAt: Scalars['ISO8601DateTime']['output'];
  decoratedName?: Maybe<Scalars['String']['output']>;
  decoratedShortName?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  defaultModifier?: Maybe<Modifier>;
  hiddenOnline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isVariant: Scalars['Boolean']['output'];
  item: Item;
  maxSelect?: Maybe<Scalars['Int']['output']>;
  minSelect?: Maybe<Scalars['Int']['output']>;
  modifiers: Array<Modifier>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Float']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ModifierGroupModifiersArgs = {
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModifierGroupAttributes = {
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isVariant?: InputMaybe<Scalars['Boolean']['input']>;
  maxSelect?: InputMaybe<Scalars['Int']['input']>;
  minSelect?: InputMaybe<Scalars['Int']['input']>;
  modifiersAttributes?: InputMaybe<Array<ModifierAttributes>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Manually adjust a customer's loyalty balance (operator action).
   *
   * Authentication: Auth Token only.
   */
  adjustLoyaltyAccount?: Maybe<AdjustLoyaltyAccountMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  assignItemGroupTaxRate?: Maybe<AssignItemGroupTaxRateMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  cancelOrderItems?: Maybe<CancelOrderItemsMutationPayload>;
  /** Authentication: Auth Token only. */
  createAssistantThread?: Maybe<CreateAssistantThreadMutationPayload>;
  /** Authentication: Auth Token only. */
  createCompletion?: Maybe<CreateCompletionMutationPayload>;
  /**
   * Generates a signed S3 URL for file uploads
   *
   * Authentication: Auth Token only.
   */
  createDirectUpload?: Maybe<CreateDirectUploadMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createDiscount?: Maybe<CreateDiscountMutationPayload>;
  /** Authentication: Auth Token only. */
  createEmployment?: Maybe<CreateEmploymentMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createInvoice?: Maybe<CreateInvoiceMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createItem?: Maybe<CreateItemMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createItemGroup?: Maybe<CreateItemGroupMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createLoyaltyProgram?: Maybe<CreateLoyaltyProgramMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createModifier?: Maybe<CreateModifierMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createModifierGroup?: Maybe<CreateModifierGroupMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createOrderExport?: Maybe<CreateOrderExportMutationPayload>;
  /** Authentication: Auth Token or anonymous access; API Key not supported. */
  createPayment?: Maybe<CreatePaymentMutationPayload>;
  /** Authentication: Auth Token only. */
  createPayout?: Maybe<CreatePayoutMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createRefund?: Maybe<CreateRefundMutationPayload>;
  /** Authentication: Auth Token only. */
  createSavedPrompt?: Maybe<CreateSavedPromptMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createScheduledOrderExport?: Maybe<CreateScheduledOrderExportMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createShift?: Maybe<CreateShiftMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  createTaxRate?: Maybe<CreateTaxRateMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  deleteShift?: Maybe<DeleteShiftMutationPayload>;
  /** Authentication: Auth Token only. */
  editAssistantThread?: Maybe<EditAssistantThreadMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editDiscount?: Maybe<EditDiscountMutationPayload>;
  /** Authentication: Auth Token only. */
  editEmployment?: Maybe<EditEmploymentMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editInvoice?: Maybe<EditInvoiceMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editItem?: Maybe<EditItemMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editItemGroup?: Maybe<EditItemGroupMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editMenu?: Maybe<EditMenuMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editModifier?: Maybe<EditModifierMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editModifierGroup?: Maybe<EditModifierGroupMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editOrder?: Maybe<EditOrderMutationPayload>;
  /** Authentication: Auth Token only. */
  editRestaurantGroup?: Maybe<EditRestaurantGroupMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editRestaurantSetting?: Maybe<EditRestaurantSettingMutationPayload>;
  /** Authentication: Auth Token only. */
  editSavedPrompt?: Maybe<EditSavedPromptMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editShift?: Maybe<EditShiftMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  editTaxRate?: Maybe<EditTaxRateMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  replaceTaxRate?: Maybe<ReplaceTaxRateMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  updateDeviceSettings?: Maybe<UpdateDeviceSettingsMutationPayload>;
  /** Authentication: Auth Token or API Key. */
  updateLoyaltyProgram?: Maybe<UpdateLoyaltyProgramMutationPayload>;
  /** Authentication: Auth Token only. */
  updateUser?: Maybe<UpdateUserMutationPayload>;
};


export type MutationAdjustLoyaltyAccountArgs = {
  input: AdjustLoyaltyAccountMutationInput;
};


export type MutationAssignItemGroupTaxRateArgs = {
  input: AssignItemGroupTaxRateMutationInput;
};


export type MutationCancelOrderItemsArgs = {
  input: CancelOrderItemsMutationInput;
};


export type MutationCreateAssistantThreadArgs = {
  input: CreateAssistantThreadMutationInput;
};


export type MutationCreateCompletionArgs = {
  input: CreateCompletionMutationInput;
};


export type MutationCreateDirectUploadArgs = {
  input: CreateDirectUploadMutationInput;
};


export type MutationCreateDiscountArgs = {
  input: CreateDiscountMutationInput;
};


export type MutationCreateEmploymentArgs = {
  input: CreateEmploymentMutationInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceMutationInput;
};


export type MutationCreateItemArgs = {
  input: CreateItemMutationInput;
};


export type MutationCreateItemGroupArgs = {
  input: CreateItemGroupMutationInput;
};


export type MutationCreateLoyaltyProgramArgs = {
  input: CreateLoyaltyProgramMutationInput;
};


export type MutationCreateModifierArgs = {
  input: CreateModifierMutationInput;
};


export type MutationCreateModifierGroupArgs = {
  input: CreateModifierGroupMutationInput;
};


export type MutationCreateOrderExportArgs = {
  input: CreateOrderExportMutationInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentMutationInput;
};


export type MutationCreatePayoutArgs = {
  input: CreatePayoutMutationInput;
};


export type MutationCreateRefundArgs = {
  input: CreateRefundMutationInput;
};


export type MutationCreateSavedPromptArgs = {
  input: CreateSavedPromptMutationInput;
};


export type MutationCreateScheduledOrderExportArgs = {
  input: CreateScheduledOrderExportMutationInput;
};


export type MutationCreateShiftArgs = {
  input: CreateShiftMutationInput;
};


export type MutationCreateTaxRateArgs = {
  input: CreateTaxRateMutationInput;
};


export type MutationDeleteShiftArgs = {
  input: DeleteShiftMutationInput;
};


export type MutationEditAssistantThreadArgs = {
  input: EditAssistantThreadMutationInput;
};


export type MutationEditDiscountArgs = {
  input: EditDiscountMutationInput;
};


export type MutationEditEmploymentArgs = {
  input: EditEmploymentMutationInput;
};


export type MutationEditInvoiceArgs = {
  input: EditInvoiceMutationInput;
};


export type MutationEditItemArgs = {
  input: EditItemMutationInput;
};


export type MutationEditItemGroupArgs = {
  input: EditItemGroupMutationInput;
};


export type MutationEditMenuArgs = {
  input: EditMenuMutationInput;
};


export type MutationEditModifierArgs = {
  input: EditModifierMutationInput;
};


export type MutationEditModifierGroupArgs = {
  input: EditModifierGroupMutationInput;
};


export type MutationEditOrderArgs = {
  input: EditOrderMutationInput;
};


export type MutationEditRestaurantGroupArgs = {
  input: EditRestaurantGroupMutationInput;
};


export type MutationEditRestaurantSettingArgs = {
  input: EditRestaurantSettingMutationInput;
};


export type MutationEditSavedPromptArgs = {
  input: EditSavedPromptMutationInput;
};


export type MutationEditShiftArgs = {
  input: EditShiftMutationInput;
};


export type MutationEditTaxRateArgs = {
  input: EditTaxRateMutationInput;
};


export type MutationReplaceTaxRateArgs = {
  input: ReplaceTaxRateMutationInput;
};


export type MutationUpdateDeviceSettingsArgs = {
  input: UpdateDeviceSettingsMutationInput;
};


export type MutationUpdateLoyaltyProgramArgs = {
  input: UpdateLoyaltyProgramMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserMutationInput;
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  closed: Scalars['Boolean']['output'];
  day: Scalars['Int']['output'];
  openingPeriods: Array<OpeningPeriod>;
};

export type OpeningHoursAttributes = {
  closed: Scalars['Boolean']['input'];
  day: Scalars['Int']['input'];
  openingPeriods: Array<OpeningPeriodAttributes>;
};

export type OpeningHoursException = {
  __typename?: 'OpeningHoursException';
  closed: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  openingPeriods: Array<OpeningPeriod>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OpeningHoursExceptionAttributes = {
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingPeriods?: InputMaybe<Array<OpeningPeriodAttributes>>;
};

export type OpeningPeriod = {
  __typename?: 'OpeningPeriod';
  endTime: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
};

export type OpeningPeriodAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  endTime: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  startTime: Scalars['Int']['input'];
};

export type Order = {
  __typename?: 'Order';
  /** Total after gift cards */
  amountCharged: Scalars['Int']['output'];
  bonus?: Maybe<Bonus>;
  cancelReason?: Maybe<CancelReason>;
  cancelableStatus: CancelableStatus;
  cashCollected?: Maybe<Scalars['Int']['output']>;
  cashReturned?: Maybe<Scalars['Int']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  delivery?: Maybe<Delivery>;
  deliveryAddress?: Maybe<DeliveryAddress>;
  deliveryFee: Scalars['Int']['output'];
  /** Portion of the tip that goes to the delivery provider */
  deliveryTip: Scalars['Int']['output'];
  discount?: Maybe<Discount>;
  /** Order level discounts */
  discountAmount: Scalars['Int']['output'];
  discountValue?: Maybe<Scalars['Int']['output']>;
  employees: Array<User>;
  estimatedDeliveryAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fulfillment: Fulfillment;
  giftCardTransaction?: Maybe<GiftCardTransaction>;
  /** Subtotal before discounts */
  grossSubtotal: Scalars['Int']['output'];
  hasBonus: Scalars['Boolean']['output'];
  hasDelivery: Scalars['Boolean']['output'];
  hasLoyaltyTransactions: Scalars['Boolean']['output'];
  hasRefund: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated tax inclusion is no longer on a per order basis - only a per item basis */
  itemPriceIncludesTax: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['ID']['output']>;
  largeParty: Scalars['Boolean']['output'];
  likers: Array<User>;
  likes: Array<Like>;
  loyaltyComps: Scalars['Int']['output'];
  loyaltyStatus?: Maybe<LoyaltyAccount>;
  loyaltyTransactions: Array<LoyaltyTransaction>;
  menu?: Maybe<Menu>;
  /** Subtotal after discounts before surcharge */
  netItemSubtotal: Scalars['Int']['output'];
  /** Amount this order contributes to net sales (excludes gift card sales) */
  netSales: Scalars['Int']['output'];
  /** Subtotal after discounts */
  netSubtotal: Scalars['Int']['output'];
  notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  numItems: Scalars['Int']['output'];
  /** @deprecated Use code instead */
  number: Scalars['String']['output'];
  orderItems: Array<OrderItem>;
  orderSurcharges: Array<OrderSurcharge>;
  packaging?: Maybe<Packaging>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  payLater: Scalars['Boolean']['output'];
  /** subtotal + unincludedTax */
  payableTotal: Scalars['Int']['output'];
  paymentIntentId?: Maybe<Scalars['ID']['output']>;
  paymentLinkUrl: Scalars['String']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentStatus: OrderPaymentStatus;
  paymentType?: Maybe<OrderPayment>;
  paymentUsers: Array<User>;
  payments: Array<Payment>;
  placedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  processingFee: Scalars['Int']['output'];
  purchasedGiftCard?: Maybe<GiftCard>;
  reaction?: Maybe<Reaction>;
  recalledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  refund?: Maybe<Refund>;
  refundableStatus: RefundableStatus;
  refundableTip: Scalars['Int']['output'];
  restaurant: Restaurant;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  /** Portion of the tip that goes to the restaurant */
  serviceFee: Scalars['Int']['output'];
  serviceFeePercent?: Maybe<Scalars['Int']['output']>;
  shifts?: Maybe<Array<Shift>>;
  source: OrderSource;
  status: OrderStatus;
  streamOrder?: Maybe<StreamOrder>;
  stripeFee?: Maybe<Scalars['Int']['output']>;
  subtotal: Scalars['Int']['output'];
  /** tableMapping code */
  table?: Maybe<Scalars['String']['output']>;
  /** table name to display */
  tableDisplayName?: Maybe<Scalars['String']['output']>;
  /** tableMapping name */
  tableMapping?: Maybe<Scalars['String']['output']>;
  tax: Scalars['Int']['output'];
  taxExempt: Scalars['Boolean']['output'];
  taxExemptNote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use unincludedTaxBasis instead */
  taxableAmount: Scalars['Float']['output'];
  ticketServers?: Maybe<Array<User>>;
  tickets?: Maybe<Array<Ticket>>;
  tip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  /** Order and item levels discounts */
  totalDiscountAmount: Scalars['Int']['output'];
  transferAmount?: Maybe<Scalars['Int']['output']>;
  unincludedTax: Scalars['Int']['output'];
  unincludedTaxBasis: Scalars['Float']['output'];
  unpaidBalance: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};


export type OrderLikesArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export enum OrderExportFormatEnum {
  /** Standard comma-separated values export */
  Csv = 'CSV',
  /** QuickBooks Online-compatible bank feed CSV (3-column: Date, Description, Amount) */
  Qbo = 'QBO'
}

export type OrderItem = {
  __typename?: 'OrderItem';
  canceled: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  canceledQuantity: Scalars['Int']['output'];
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customItemGroup?: Maybe<ItemGroup>;
  discount?: Maybe<Discount>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  instructionsPrice?: Maybe<Scalars['Int']['output']>;
  item: Item;
  itemRefund?: Maybe<ItemRefund>;
  key: Scalars['ID']['output'];
  loyaltyComped: Scalars['Boolean']['output'];
  loyaltyCompedModifiers: Scalars['Boolean']['output'];
  modifiers?: Maybe<Array<Modifier>>;
  name: Scalars['String']['output'];
  order: Order;
  preLoyaltyPrice: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  refundableItemTotal: Scalars['Int']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxRate: TaxRate;
  undiscountedPrice: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OrderOrderByAttributes = {
  netItemSubtotal?: InputMaybe<SortDirection>;
  paidAt?: InputMaybe<SortDirection>;
  purchasedGiftCardAmount?: InputMaybe<SortDirection>;
  reaction?: InputMaybe<SortDirection>;
  refundedSubtotal?: InputMaybe<SortDirection>;
  restaurantName?: InputMaybe<SortDirection>;
  sequence?: InputMaybe<SortDirection>;
  serviceFee?: InputMaybe<SortDirection>;
  subtotal?: InputMaybe<SortDirection>;
  total?: InputMaybe<SortDirection>;
  totalDiscounts?: InputMaybe<SortDirection>;
};

export enum OrderPayment {
  CardManualEntry = 'CARD_MANUAL_ENTRY',
  /** Credit Card */
  CardPresent = 'CARD_PRESENT',
  CardStored = 'CARD_STORED',
  /** Cash */
  Cash = 'CASH',
  /** Paid outside Avocado */
  External = 'EXTERNAL',
  /** Gift Card */
  GiftCard = 'GIFT_CARD',
  /** Legacy Online - no processing fee */
  LegacyOnline = 'LEGACY_ONLINE',
  NoPayment = 'NO_PAYMENT',
  /** Online */
  Online = 'ONLINE',
  Split = 'SPLIT',
  UsBankAccount = 'US_BANK_ACCOUNT'
}

export enum OrderPaymentStatus {
  /** Authorized */
  Authorized = 'AUTHORIZED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Paid */
  Paid = 'PAID',
  /** Pending */
  Pending = 'PENDING',
  /** Unpaid */
  Unpaid = 'UNPAID'
}

export enum OrderSource {
  /** Mobile */
  Mobile = 'MOBILE',
  /** POS */
  Pos = 'POS'
}

export enum OrderStatus {
  /** Visible on KDS */
  Accepted = 'ACCEPTED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Deprecated - Customer Charged */
  Charged = 'CHARGED',
  /** Deprecated - In process of getting charged */
  ChargePending = 'CHARGE_PENDING',
  /** Order prepared */
  Completed = 'COMPLETED',
  /** Shopping Cart Mode */
  Created = 'CREATED',
  /** Finalized by customer, but not visible on KDS */
  Placed = 'PLACED',
  /** Deprecated - Move from completed to accepted */
  Recalled = 'RECALLED',
  /** Open tab with tickets, not visible in KDS */
  TabOpened = 'TAB_OPENED'
}

export type OrderSurcharge = {
  __typename?: 'OrderSurcharge';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  refundableTotal: Scalars['Int']['output'];
  surcharge: Surcharge;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum Packaging {
  /** Dine in */
  DineIn = 'DINE_IN',
  /** To go */
  ToGo = 'TO_GO'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  /** Tip that is not part of the required largePartyTip */
  additionalTip?: Maybe<Scalars['Int']['output']>;
  /** Subtotal and tax */
  amount: Scalars['Int']['output'];
  cashCollected?: Maybe<Scalars['Int']['output']>;
  /** Signed amount added to this cash payment to reach the nearest nickel */
  cashRoundingAdjustment: Scalars['Int']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  delayedTip?: Maybe<Scalars['Int']['output']>;
  deliveryTip?: Maybe<Scalars['Int']['output']>;
  giftCard?: Maybe<GiftCard>;
  giftCardTransaction?: Maybe<GiftCardTransaction>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  key: Scalars['ID']['output'];
  largePartyTip?: Maybe<Scalars['Int']['output']>;
  merchantFee: Scalars['Int']['output'];
  order: Order;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentOrderItems?: Maybe<Array<PaymentOrderItem>>;
  paymentType: OrderPayment;
  processingFee: Scalars['Int']['output'];
  serviceFee?: Maybe<Scalars['Int']['output']>;
  status: OrderPaymentStatus;
  stripeFee?: Maybe<Scalars['Int']['output']>;
  tip?: Maybe<Scalars['Int']['output']>;
  tipDelayed: Scalars['Boolean']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  last4?: Maybe<Scalars['String']['output']>;
};

export type PaymentOrderItem = {
  __typename?: 'PaymentOrderItem';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  orderItem: OrderItem;
  payment: Payment;
  price: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Payout = {
  __typename?: 'Payout';
  bonus: Scalars['Int']['output'];
  capitalRepaymentAmount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  debits: Scalars['Int']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  fee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  merchantFee: Scalars['Int']['output'];
  mercuryTransactionId?: Maybe<Scalars['ID']['output']>;
  ordersEndAt: Scalars['ISO8601DateTime']['output'];
  ordersStartAt: Scalars['ISO8601DateTime']['output'];
  payoutMethod: Scalars['String']['output'];
  restaurant: Restaurant;
  salesTaxTransactionId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripeBalanceAdjustment?: Maybe<Scalars['Int']['output']>;
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  tips: Scalars['Int']['output'];
  transferredAmount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum Permission {
  /** Can manage the associated stripe account */
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  /** Can authenticate the POS / KDS */
  PosAuth = 'POS_AUTH',
  /** Receives notification on negative reactions */
  ReactionRecipient = 'REACTION_RECIPIENT',
  /** Can view reports */
  Reporting = 'REPORTING',
  /** System account which has full access */
  System = 'SYSTEM'
}

export type Query = {
  __typename?: 'Query';
  /** Authentication: Auth Token only. */
  assistantThread?: Maybe<AssistantThread>;
  /** Authentication: Auth Token only. */
  assistantThreads: Array<AssistantThread>;
  /** Authentication: Auth Token or API Key. */
  customer: CustomerStats;
  /** Authentication: Auth Token or API Key. */
  customers: Array<CustomerStats>;
  /** Authentication: Auth Token or API Key. */
  customershipsConnection: CustomershipConnection;
  /** Authentication: Auth Token only. */
  deliveryQuote: Scalars['Int']['output'];
  /** Authentication: Auth Token or API Key. */
  employment: Employment;
  /** Authentication: Auth Token or API Key. */
  employments: Array<Employment>;
  /** Authentication: Auth Token or API Key. */
  giftCard?: Maybe<GiftCard>;
  /** Authentication: Auth Token or API Key. */
  giftCards: Array<GiftCard>;
  /** Authentication: Auth Token only. */
  instantPayoutPreview: InstantPayoutPreview;
  /** Authentication: Auth Token or API Key. */
  invoice: Invoice;
  /** Authentication: Auth Token or API Key. */
  invoices: Array<Invoice>;
  /** Authentication: Auth Token or API Key. */
  invoicesConnection: InvoiceConnection;
  /** Authentication: Auth Token or anonymous access; API Key not supported. */
  me?: Maybe<User>;
  /** Authentication: Auth Token or API Key. */
  order: Order;
  /** Authentication: Auth Token only. */
  payout: Payout;
  /** Authentication: Auth Token only. */
  payouts: Array<Payout>;
  /** Authentication: Auth Token or API Key. */
  restaurant?: Maybe<Restaurant>;
  /** Authentication: Auth Token only. */
  runMessages?: Maybe<RunMessages>;
  /** Authentication: Auth Token only. */
  savedPrompts: Array<SavedPrompt>;
  /** Authentication: Auth Token or API Key. */
  scheduledOrdersConnection: OrderConnection;
  /** Authentication: Auth Token or API Key. */
  shift: Shift;
  /** Authentication: Auth Token or API Key. */
  shifts: Array<Shift>;
  /** Authentication: Auth Token or API Key. */
  stats: RestaurantStats;
  /** Authentication: Auth Token only. */
  stripeAccountLink: StripeAccountLink;
  /** Authentication: Auth Token only. */
  stripeAccountSession: AccountSession;
  /** Authentication: Auth Token only. */
  stripeAccounts: Array<StripeAccount>;
};


export type QueryAssistantThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCustomersArgs = {
  restaurantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCustomershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomershipOrderByAttributes>;
  restaurantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryDeliveryQuoteArgs = {
  deliveryAddressId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


export type QueryEmploymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmploymentsArgs = {
  restaurantIds: Array<Scalars['ID']['input']>;
};


export type QueryGiftCardArgs = {
  code: Scalars['String']['input'];
};


export type QueryGiftCardsArgs = {
  restaurantIds: Array<Scalars['ID']['input']>;
};


export type QueryInstantPayoutPreviewArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  restaurantIds: Array<Scalars['ID']['input']>;
};


export type QueryInvoicesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvoiceOrderByAttributes>;
  restaurantIds: Array<Scalars['ID']['input']>;
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayoutsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  restaurantIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRunMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  runId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type QueryScheduledOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScheduledOrderOrderByAttributes>;
  restaurantIds: Array<Scalars['ID']['input']>;
  scheduledAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  scheduledBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<Array<OrderStatus>>;
};


export type QueryShiftArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShiftsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  restaurantIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryStatsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  endTime?: InputMaybe<Scalars['Int']['input']>;
  restaurantIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  startTime?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStripeAccountLinkArgs = {
  id: Scalars['ID']['input'];
  refreshUrl: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  type: StripeAccountLinkTypeEnum;
};


export type QueryStripeAccountSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStripeAccountsArgs = {
  restaurantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Reaction = {
  __typename?: 'Reaction';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order: Order;
  reasons?: Maybe<Array<Reason>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Reason = {
  __typename?: 'Reason';
  id: Scalars['ID']['output'];
  isPositive: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export enum RedemptionSurface {
  /** Counts items a customer could actually order online right now. */
  Online = 'ONLINE',
  /** Counts items a cashier at the POS could actually sell right now. */
  Pos = 'POS'
}

export type Refund = {
  __typename?: 'Refund';
  /** Signed cash-rounding amount returned with a full refund; zero for partial refunds */
  cashRoundingAdjustment: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  processingFee?: Maybe<Scalars['Int']['output']>;
  serviceFee?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tip?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  transferAmount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum RefundableStatus {
  /** Delivery order */
  Delivery = 'DELIVERY',
  /** Refund window expired */
  Expired = 'EXPIRED',
  /** Free order */
  Free = 'FREE',
  /** Gift card purchase */
  GiftCardPurchased = 'GIFT_CARD_PURCHASED',
  /** Gift card used */
  GiftCardTransaction = 'GIFT_CARD_TRANSACTION',
  /** Can be refunded */
  Refundable = 'REFUNDABLE',
  /** Refunded */
  Refunded = 'REFUNDED',
  /** Used two or more payment methods */
  SplitPayment = 'SPLIT_PAYMENT',
  /** Unpaid */
  Unpaid = 'UNPAID'
}

/** Autogenerated input type of ReplaceTaxRateMutation */
export type ReplaceTaxRateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  rate: Scalars['Int']['input'];
};

/** Autogenerated return type of ReplaceTaxRateMutation. */
export type ReplaceTaxRateMutationPayload = {
  __typename?: 'ReplaceTaxRateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  taxRate?: Maybe<TaxRate>;
};

export type Restaurant = {
  __typename?: 'Restaurant';
  address?: Maybe<Address>;
  bonusable: Scalars['Boolean']['output'];
  cardFeeCents: Scalars['Int']['output'];
  cardFeePercent: Scalars['Float']['output'];
  cashFeeCents: Scalars['Int']['output'];
  cashFeePercent: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentMenu: Menu;
  customItem: Item;
  /** Seconds after midnight when the day starts/ends */
  dayOffset: Scalars['Int']['output'];
  defaultPackaging: Packaging;
  defaultTaxRate: TaxRate;
  devices: Array<Device>;
  discounts: Array<Discount>;
  employments: Array<Employment>;
  /** @deprecated Use visible */
  enabled: Scalars['Boolean']['output'];
  /** @deprecated Use cardFeePercent */
  feePercent: Scalars['Float']['output'];
  feeSchedules: Array<FeeSchedule>;
  giftCardItem: Item;
  giftCards: Array<GiftCard>;
  hasActiveCashDrawers: Scalars['Boolean']['output'];
  hasActiveStreamLocationConnection: Scalars['Boolean']['output'];
  hasPickup: Scalars['Boolean']['output'];
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoices: Array<Invoice>;
  kioskBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  largePartyDefaultTipPercent?: Maybe<Scalars['Float']['output']>;
  logoImageUrl?: Maybe<Scalars['String']['output']>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  /** Menus */
  menus?: Maybe<Array<Menu>>;
  name?: Maybe<Scalars['String']['output']>;
  notifyOrderComplete: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  restaurantGroup: RestaurantGroup;
  salesTaxPercent: Scalars['Float']['output'];
  /** 1000x the salesTaxPercent */
  salesTaxRate: Scalars['Int']['output'];
  setting: RestaurantSetting;
  statementDescriptor: Scalars['String']['output'];
  statementDescriptorSuffix?: Maybe<Scalars['String']['output']>;
  stations: Array<Station>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  /** Whether Stripe has approved this restaurant to accept card payments. Backed by a live Stripe::Account.retrieve call — only request when the caller specifically needs the boot-time onboarding-recovery signal. Returns null for viewers without the reporting/device-management gate and null on Stripe transport errors (distinguishable from a false). */
  stripeChargesEnabled?: Maybe<Scalars['Boolean']['output']>;
  submenus: Array<Submenu>;
  surcharges: Array<Surcharge>;
  tableMappings: Array<TableMapping>;
  tagline?: Maybe<Scalars['String']['output']>;
  taxRates: Array<TaxRate>;
  timeZone: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userRestaurantSettings: Array<UserRestaurantSetting>;
  visible: Scalars['Boolean']['output'];
  waitTime?: Maybe<Scalars['Int']['output']>;
};


export type RestaurantCurrentMenuArgs = {
  menuId?: InputMaybe<Scalars['ID']['input']>;
};


export type RestaurantDiscountsArgs = {
  kind?: InputMaybe<DiscountKind>;
};

export type RestaurantGroup = {
  __typename?: 'RestaurantGroup';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Authentication: Auth Token only. */
  giftCards: Array<GiftCard>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  restaurants: Array<Restaurant>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  wordmarkUrl?: Maybe<Scalars['String']['output']>;
};

export type RestaurantSetting = {
  __typename?: 'RestaurantSetting';
  algolia: Algolia;
  assistantContext?: Maybe<Scalars['String']['output']>;
  /** When true, POS cash payments are rounded to the nearest nickel. */
  cashRoundingEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  enableDelivery: Scalars['Boolean']['output'];
  enableKiosk: Scalars['Boolean']['output'];
  enablePoem: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  itemPriceIncludesTax: Scalars['Boolean']['output'];
  largePartyDefaultTipPercent?: Maybe<Scalars['Int']['output']>;
  onlineAutoAccept: Scalars['Boolean']['output'];
  /** Seconds after midnight when the day starts/ends */
  openingHours?: Maybe<Array<OpeningHours>>;
  openingHoursExceptions: Array<OpeningHoursException>;
  /** Hours past midnight when payouts are sent out in to the restaurant's timezone */
  payoutHour: Scalars['Int']['output'];
  /** When true, each iPad has its own active cash drawer. When false (default), the restaurant has a single shared drawer. */
  perDeviceCashDrawers: Scalars['Boolean']['output'];
  pickupInstructions?: Maybe<Scalars['String']['output']>;
  restaurant: Restaurant;
  /** Sales tax rate in thousandths of a percent (e.g. 10.55% = 10550) */
  salesTaxRate: Scalars['Int']['output'];
  showEmployeeFinancials: Scalars['Boolean']['output'];
  signageConfig?: Maybe<Scalars['JSON']['output']>;
  /** Number of customers who clicked the external review link. */
  socialReviewClickCount: Scalars['Int']['output'];
  /** External review URL (Google, Yelp, etc.) shown after a positive reaction. https:// only. When present, customers who leave a positive reaction see a prompt linking to this URL; when blank, the feature is off. */
  socialReviewsUrl?: Maybe<Scalars['String']['output']>;
  storefront: StorefrontSetting;
  stripeTerminalLocation?: Maybe<Scalars['String']['output']>;
  tipAfterTax: Scalars['Boolean']['output'];
  tipAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  tipPercentages: Array<Scalars['Int']['output']>;
  tipThreshold?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waitTime?: Maybe<Scalars['Int']['output']>;
  withholdSalesTax: Scalars['Boolean']['output'];
};

export type RestaurantStats = {
  __typename?: 'RestaurantStats';
  averageSale: Scalars['Int']['output'];
  averageTip: Scalars['Int']['output'];
  averageTipPercent: Scalars['Float']['output'];
  /** Card and online payments from orders and fully paid invoices recognized in the selected reporting period */
  cardPayments: Scalars['Int']['output'];
  /** Physical cash collected, including cash-rounding adjustments */
  cashPayments: Scalars['Int']['output'];
  /** Signed net cash-rounding amount collected in the selected reporting period */
  cashRoundingAdjustment: Scalars['Int']['output'];
  deliveryFee: Scalars['Int']['output'];
  deliveryTips: Scalars['Int']['output'];
  expectedPayout: Scalars['Int']['output'];
  /** Nonzero Stream order net totals grouped by provider */
  externalOrderTotalsBySource: Array<ExternalOrderTotal>;
  giftCardPayments: Scalars['Int']['output'];
  /** Total sales of gift cards */
  giftCardSales: Scalars['Int']['output'];
  grossSales: Scalars['Int']['output'];
  grossSubtotal: Scalars['Int']['output'];
  hourlySales: Array<HourlySales>;
  invoiceNetTotal: Scalars['Int']['output'];
  loyaltyComps: Scalars['Int']['output'];
  merchantFee: Scalars['Int']['output'];
  netSales: Scalars['Int']['output'];
  netSalesRefunds: Scalars['Int']['output'];
  netTotal: Scalars['Int']['output'];
  numOrders: Scalars['Int']['output'];
  numRefunds: Scalars['Int']['output'];
  orders: Array<Order>;
  ordersConnection: OrderConnection;
  processingFee: Scalars['Int']['output'];
  purchasedGiftCardAmount: Scalars['Int']['output'];
  restaurants: Array<Restaurant>;
  salesTaxWithheld: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  surchargeAmount: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  /** @deprecated Renamed to averageTipPercent */
  tipPercent: Scalars['Float']['output'];
  tips: Scalars['Int']['output'];
  topAddons: Array<ItemStats>;
  topItems: Array<ItemStats>;
  totalDiscounts: Scalars['Int']['output'];
  totalRefunds: Scalars['Int']['output'];
  /** Full-business-day Z report; startTime and endTime filters do not apply */
  zReport: ZReportStats;
};


export type RestaurantStatsOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderOrderByAttributes>;
};

export type RunMessages = {
  __typename?: 'RunMessages';
  messages?: Maybe<Scalars['JSON']['output']>;
  run: Scalars['JSON']['output'];
};

export type SavedPrompt = {
  __typename?: 'SavedPrompt';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['Float']['output']>;
  prompt: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Schedule = {
  __typename?: 'Schedule';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Day of the week - 1 is Monday, 7 is Sunday */
  day: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  /** End time in seconds from midnight */
  endTime: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  itemGroup: ItemGroup;
  /** Start time in seconds from midnight */
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ScheduleAttributes = {
  day?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduledOrderOrderByAttributes = {
  paidAt?: InputMaybe<SortDirection>;
  restaurantName?: InputMaybe<SortDirection>;
  scheduledAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  subtotal?: InputMaybe<SortDirection>;
};

export type Shift = {
  __typename?: 'Shift';
  bonusAmount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  employment: Employment;
  endAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  orders: Array<Order>;
  restaurant: Restaurant;
  startAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use orders */
  tippableOrders: Array<Order>;
  tips: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export enum SortDirection {
  /** Ascending */
  Asc = 'ASC',
  /** Descending */
  Desc = 'DESC'
}

export type Station = {
  __typename?: 'Station';
  /** Assignable to a KDS */
  assignable: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  restaurantId: Restaurant;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type StorefrontSetting = {
  __typename?: 'StorefrontSetting';
  banner?: Maybe<Scalars['String']['output']>;
  defaultTipAmount?: Maybe<Scalars['Int']['output']>;
  defaultTipPercent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Renamed to defaultTipPercent */
  defaultTipPercentage?: Maybe<Scalars['Int']['output']>;
  enableOnlineSpecialInstructions: Scalars['Boolean']['output'];
  tipAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  tipPercentages: Array<Scalars['Int']['output']>;
  tipThreshold?: Maybe<Scalars['Int']['output']>;
};

export type StreamOrder = {
  __typename?: 'StreamOrder';
  brandLabel: Scalars['String']['output'];
  customerPhoneCode?: Maybe<Scalars['String']['output']>;
  deliveryDriverName?: Maybe<Scalars['String']['output']>;
  deliveryDriverPhone?: Maybe<Scalars['String']['output']>;
  deliveryDropoffEtaAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryHandoffInstructions?: Maybe<Scalars['String']['output']>;
  deliveryPasscode?: Maybe<Scalars['String']['output']>;
  deliveryPickupEtaAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  dspOrderNumber: Scalars['String']['output'];
  fulfillmentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sourceLabel: Scalars['String']['output'];
  streamStatus: Scalars['String']['output'];
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  requirements: Scalars['JSON']['output'];
};

export type StripeAccountLink = {
  __typename?: 'StripeAccountLink';
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
};

export enum StripeAccountLinkTypeEnum {
  /** Provides a form for inputting outstanding requirements. Send the user to the form in this mode to just collect the new information you need. */
  Onboarding = 'ONBOARDING',
  /** Displays the fields that are already populated on the account object, and allows your user to edit previously provided information. */
  Update = 'UPDATE'
}

export type Submenu = {
  __typename?: 'Submenu';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  restaurant: Restaurant;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Surcharge = {
  __typename?: 'Surcharge';
  automaticOnline: Scalars['Boolean']['output'];
  automaticQuickOrder: Scalars['Boolean']['output'];
  automaticTable: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameWithValue: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  restaurant: Restaurant;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type TableMapping = {
  __typename?: 'TableMapping';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: TableMappingKind;
  name: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum TableMappingKind {
  /** A dine-in table */
  DineIn = 'DINE_IN',
  /** A pickup location */
  PickupLocation = 'PICKUP_LOCATION'
}

export type TaxRate = {
  __typename?: 'TaxRate';
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
  rate: Scalars['Int']['output'];
};

export type Ticket = {
  __typename?: 'Ticket';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  orderItems: Array<OrderItem>;
  placedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  recalledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  server?: Maybe<User>;
  status: OrderStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of UpdateDeviceSettingsMutation */
export type UpdateDeviceSettingsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientUuid: Scalars['String']['input'];
  expectedSettingsUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  patch?: InputMaybe<EditableDeviceSettingsInput>;
  restaurantId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateDeviceSettingsMutation. */
export type UpdateDeviceSettingsMutationPayload = {
  __typename?: 'UpdateDeviceSettingsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateLoyaltyProgramMutation */
export type UpdateLoyaltyProgramMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  earningItemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  earningThreshold?: InputMaybe<Scalars['Int']['input']>;
  earningType?: InputMaybe<Scalars['String']['input']>;
  enrollmentDescription?: InputMaybe<Scalars['String']['input']>;
  enrollmentHeading?: InputMaybe<Scalars['String']['input']>;
  enrollmentScreenPlacement?: InputMaybe<LoyaltyEnrollmentPlacement>;
  id: Scalars['ID']['input'];
  pointsPerDollar?: InputMaybe<Scalars['Int']['input']>;
  progressMessage?: InputMaybe<Scalars['String']['input']>;
  rewardEarnedMessage?: InputMaybe<Scalars['String']['input']>;
  rewardIncludesModifiers?: InputMaybe<Scalars['Boolean']['input']>;
  rewardItemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  smsProgressEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  starterPoints?: InputMaybe<Scalars['Int']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLoyaltyProgramMutation. */
export type UpdateLoyaltyProgramMutationPayload = {
  __typename?: 'UpdateLoyaltyProgramMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
};

/** Autogenerated input type of UpdateUserMutation */
export type UpdateUserMutationInput = {
  avatarBlobId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultDeliveryAddressId?: InputMaybe<Scalars['ID']['input']>;
  deliveryAddressesAttributes?: InputMaybe<Array<DeliveryAddressAttributes>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasConfirmedName?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserMutation. */
export type UpdateUserMutationPayload = {
  __typename?: 'UpdateUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  /** Authentication: Auth Token only. */
  authType: Auth;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Authentication: Auth Token only. */
  defaultDeliveryAddress?: Maybe<DeliveryAddress>;
  /** Authentication: Auth Token only. */
  defaultDeliveryAddressId?: Maybe<Scalars['ID']['output']>;
  /** Authentication: Auth Token only. */
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  /** Authentication: Auth Token only. */
  deliveryAddresses: Array<DeliveryAddress>;
  email?: Maybe<Scalars['String']['output']>;
  employers: Array<Restaurant>;
  employments: Array<Employment>;
  /** Authentication: Auth Token only. */
  firebaseId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasConfirmedName: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEmployed: Scalars['Boolean']['output'];
  /** Authentication: Auth Token only. */
  isSuperAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Authentication: Auth Token only. */
  payments: Array<Payment>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userRestaurantSettings: Array<UserRestaurantSetting>;
};


export type UserEmployersArgs = {
  permission?: InputMaybe<Permission>;
};


export type UserEmploymentsArgs = {
  permission?: InputMaybe<Permission>;
};


export type UserUserRestaurantSettingsArgs = {
  restaurantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserRestaurantSetting = {
  __typename?: 'UserRestaurantSetting';
  canMarket?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  restaurant: Restaurant;
  user: User;
};

export type ZReportStats = {
  __typename?: 'ZReportStats';
  cardPayments: Scalars['Int']['output'];
  cashPayments: Scalars['Int']['output'];
  cashRoundingAdjustment: Scalars['Int']['output'];
  giftCardPayments: Scalars['Int']['output'];
  /** Gift-card sales net of refunds issued during the reporting period */
  giftCardSales: Scalars['Int']['output'];
  /** Sales before discounts, loyalty redemptions, tax, and refunds */
  grossSales: Scalars['Int']['output'];
  loyaltyComps: Scalars['Int']['output'];
  /** Sales after discounts, loyalty redemptions, tax, and refunds */
  netSales: Scalars['Int']['output'];
  /** Sales total, tips, deferred sales, and cash rounding */
  netTotal: Scalars['Int']['output'];
  numOrders: Scalars['Int']['output'];
  numPayments: Scalars['Int']['output'];
  numRefunds: Scalars['Int']['output'];
  otherPayments: Scalars['Int']['output'];
  /** Paid invoice principal and tax, excluding tips and processing fees */
  paidInvoices: Scalars['Int']['output'];
  /** Payments captured minus refunds issued during the reporting period */
  paymentTotal: Scalars['Int']['output'];
  /** Total value refunded during the reporting period */
  refundTotal: Scalars['Int']['output'];
  /** Pre-tax sales refunded during the reporting period */
  salesRefunds: Scalars['Int']['output'];
  /** Net sales plus tax, excluding tips and deferred sales */
  salesTotal: Scalars['Int']['output'];
  /** Sales tax net of refunds issued during the reporting period */
  tax: Scalars['Int']['output'];
  /** Order and paid-invoice tips net of refunds issued during the reporting period */
  tips: Scalars['Int']['output'];
  totalDiscounts: Scalars['Int']['output'];
};
